import { createMachine } from 'xstate';

var dropdownMachine = createMachine({
    predictableActionArguments: true,
    id: "dropdown",
    initial: "closed",
    states: {
        closed: {
            on: {
                DISABLE: "disabled",
                TOGGLE: "open",
                OPEN: "open",
            },
        },
        disabled: {
            on: { ENABLE: "closed" },
        },
        open: {
            on: {
                TOGGLE: "closed",
                CLOSE: "closed",
                keyDownEscape: "closed",
            },
        },
    },
});

export { dropdownMachine };
//# sourceMappingURL=dropdownMachine.js.map
